import React from 'react';
import { ModuleForm } from '../components/shared/ModuleForm';

const MODULE_TITLES: Record<string, string> = {
  finance:    'Formulaire Finance',
  hr:         'Formulaire Ressources Humaines',
  logistique: 'Formulaire Logistique',
  formation:  'Formulaire Formation',
  lean:       'Formulaire LEAN & Performance',
};

const MODULE_SUBTITLES: Record<string, string> = {
  finance:    'Saisie des données financières et budgétaires',
  hr:         'Saisie des données du personnel',
  logistique: 'Saisie des données de la flotte et des actifs',
  formation:  'Saisie des données de formation',
  lean:       'Saisie des données d\'amélioration continue',
};

export const FormPage = ({ moduleId, user }: { moduleId: string; user: any }) => (
  <div className="p-4 md:p-6">
    <div className="mb-5">
      <h1 className="text-2xl font-bold text-white mb-1">{MODULE_TITLES[moduleId]}</h1>
      <p className="text-gray-400 text-sm">{MODULE_SUBTITLES[moduleId]}</p>
    </div>
    <ModuleForm moduleId={moduleId as any} user={user} />
  </div>
);
